<div class="status-container">
  <!-- to show the report/status of after uploading CSV -->
  <ng-container *ngIf="data.category == 'csv-upload'">
    <div class="status-info text-center">
      <h4 class="text-center">{{message}}</h4>
      <div class="table-scroll table-hover mt-25" *ngIf="statusData && statusData.length > 0">
        <table class="table">
          <thead>
            <tr>
              <th>Email ID</th>
              <th>Message</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let error of statusData">
              <td>{{error.id}}</td>
              <td>{{error.message}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <button type="button" class="btn-status mr-10" (click)="closeModal('close')">Okay</button>
      <button type="button" class="btn-status" *ngIf="statusData && statusData.length > 0"
        (click)="closeModal('download')">Download</button>
    </div>
  </ng-container>
</div>